import Navbar from "../../components/common/Navbar.js"
import Header from "../../components/common/Header.js"
import Fixtures from "../../components/team-hub/fixtures/Fixtures"
import Roster from "../../components/team-hub/roster/Roster"
import Lineup from "../../components/team-hub/lineup/Lineup"
import Tabs from "../../components/team-hub/Tabs"
import { useState } from "react"
import Tables from "../../components/team-hub/tables/Tables"
import EmptyRooster from "../../components/team-hub/roster/EmptyRooster.js"
import styled from "styled-components"
import { useLeague } from "../../context/useLeague"
import Footer from "../../components/common/Footer.js"
import { FC } from "react";
import {useUser} from "../../context/useUser";
import LeagueStatsTable from "../../components/team-hub/stats/LeagueStatsTable"

const TeamHub: FC = ({}) => {

  const { league, leagueTeams } = useLeague()
  const { user } = useUser()

  // the component currently rendered
  const [component, setComponent] = useState("Squad")

  // the component tabs
  const [components, setComponents] = useState([
    "Squad",
    "Line Up",
    "Fixtures",
    "League",
    "Stats",
  ])

  return (
    <>
      <Navbar />
      <Header title={"Team Hub"} />
          <Container className="container body" id="custom-team-hub">
            <div className="row">
              <div className="col mt-2">
                <Tabs
                    components={components}
                    setComponent={setComponent}
                    component={component}
                />
              </div>
              <div className="w-100"></div> {/* important */}
              <div
                  className={`col ${component === "League" ? "" : null}`}
                  id={`${component === "League" ? "custom-dark-bg" : "background"}`}
              >
                <div className="mt-4 mt-sm-5 pb-5">
                  {component === "Fixtures" && <Fixtures />}
                  {component === "Line Up" && <Lineup />}
                  {component === "Squad" && <Roster />}
                  {component === "Rooster" && <EmptyRooster />}
                  {component === "League" && (
                      <div className="mb-4 ">
                        <Tables />
                      </div>
                  )}
                  {component === "Stats" && league && leagueTeams &&
                    <LeagueStatsTable leagueId={league._id} teams={leagueTeams} />
                  }
                </div>
              </div>
            </div>
          </Container>
      <Footer />
    </>
  )
}

export default TeamHub

const Container = styled.div`
  @media (max-width: 991px) {
    padding: 0 2rem;
  }
  @media (max-width: 480px) {
    padding: 0 1rem;
  }
  @media (max-width: 390px) {
    padding: 0 0.5rem;
  }
`
